import { Component, OnInit, Input, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { ModalController, GestureController } from '@ionic/angular';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss'],
})
export class ConfirmModalComponent implements OnInit, AfterViewInit {
  @Input() buttonText: string;
  
  @ViewChild('container', { read: ElementRef }) container: ElementRef;
  @ViewChild('sheet', { read: ElementRef }) sheet: ElementRef;

  constructor(private modalCtrl: ModalController, private gestureCtrl: GestureController) { }

  ngOnInit() {}

  ngAfterViewInit() {
    let startY: number;
    const swipeDownGesture = this.gestureCtrl.create({
      el: this.sheet.nativeElement,
      direction: 'y',
      threshold: 5,
      gestureName: 'swipe-down-bottom-sheet',
      onStart: ev => {
        startY = ev.currentY;
        this.container.nativeElement.style.overflowY = 'hidden';
      },
      onMove: ev => {
        this.sheet.nativeElement.style.transform = `translate(0, ${Math.max(ev.currentY-startY, 0)}px)`;
      },
      onEnd: ev => {
        if (ev.currentY - startY > 20) {
          this.modalCtrl.dismiss(false);
        } else {
          this.sheet.nativeElement.style.transform = `translate(0, 0)`;
          this.container.nativeElement.style.overflowY = '';
        }
      }
    });
    swipeDownGesture.enable(true);
  }

  async setResult(didConfirm: boolean) {
    await this.modalCtrl.dismiss(didConfirm);
  }

}
